module.exports = __webpack_public_path__ + "static/media/food.fa20853e.png";